import siteConfig from "../../../site/config/site";

const SOCIALS = [
  { id: "instagram", label: "Instagram" },
  { id: "facebook", label: "Facebook" },
  { id: "pinterest", label: "Pinterest" },
  { id: "tiktok", label: "TikTok" },
  { id: "linkedin", label: "LinkedIn" },
  { id: "youtube", label: "YouTube" },
];

function SocialIcon({ id }) {
  const commonProps = {
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
  };

  if (id === "instagram") {
    return (
      <svg {...commonProps}>
        <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.7" />
        <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.7" />
        <circle cx="17.4" cy="6.7" r="1" fill="currentColor" />
      </svg>
    );
  }

  if (id === "facebook") {
    return (
      <svg {...commonProps} fill="currentColor">
        <path d="M13.8 21v-8h2.8l.45-3.25H13.8V7.68c0-.94.27-1.58 1.63-1.58h1.73V3.2c-.3-.04-1.33-.12-2.54-.12-2.5 0-4.22 1.53-4.22 4.34v2.33H7.57V13h2.83v8h3.4Z" />
      </svg>
    );
  }

  if (id === "pinterest") {
    return (
      <svg {...commonProps} fill="currentColor">
        <path d="M12 2.8a9.2 9.2 0 0 0-3.35 17.77c-.08-1.52-.02-3.34.38-5.05l1.18-5s-.3-.6-.3-1.48c0-1.39.8-2.43 1.82-2.43.86 0 1.27.64 1.27 1.42 0 .86-.55 2.14-.83 3.33-.24 1 .5 1.82 1.48 1.82 1.78 0 3.14-1.88 3.14-4.58 0-2.4-1.72-4.07-4.18-4.07-2.85 0-4.52 2.14-4.52 4.35 0 .86.33 1.79.75 2.29.08.1.09.18.07.29l-.28 1.14c-.05.18-.15.22-.34.13-1.28-.6-2.08-2.46-2.08-3.96 0-3.22 2.34-6.18 6.75-6.18 3.54 0 6.3 2.53 6.3 5.9 0 3.52-2.22 6.35-5.3 6.35-1.03 0-2-.53-2.33-1.16l-.64 2.42c-.23.89-.86 2-1.28 2.68.97.3 1.99.46 3.05.46A9.2 9.2 0 0 0 12 2.8Z" />
      </svg>
    );
  }

  if (id === "tiktok") {
    return (
      <svg {...commonProps} fill="currentColor">
        <path d="M14.1 3h3.05c.22 1.55 1.1 2.78 2.65 3.7v3.05a8.16 8.16 0 0 1-2.72-.86v5.63a6.1 6.1 0 1 1-5.27-6.04v3.08a3.02 3.02 0 1 0 2.29 2.93V3Z" />
      </svg>
    );
  }

  if (id === "linkedin") {
    return (
      <svg {...commonProps} fill="currentColor">
        <rect x="3" y="9" width="4" height="12" rx=".8" />
        <circle cx="5" cy="5.2" r="2.2" />
        <path d="M10 9h3.82v1.65h.06c.53-1.01 1.83-2.07 3.77-2.07 4.03 0 4.78 2.65 4.78 6.1V21h-4v-5.6c0-1.34-.03-3.06-1.87-3.06-1.87 0-2.16 1.46-2.16 2.96V21h-4.4V9Z" />
      </svg>
    );
  }

  return (
    <svg {...commonProps}>
      <rect x="2.5" y="5.5" width="19" height="13" rx="4" stroke="currentColor" strokeWidth="1.7" />
      <path d="m10 9 5 3-5 3V9Z" fill="currentColor" />
    </svg>
  );
}

export default function SocialLinks({
  compact = false,
  className = "",
}) {
  const links = SOCIALS.map((item) => ({
    ...item,
    url: siteConfig.socials?.[item.id] || "",
  })).filter((item) => item.url);

  if (links.length === 0) {
    return null;
  }

  return (
    <div
      className={`
        flex
        flex-wrap
        items-center
        gap-2.5
        ${className}
      `}
      aria-label="Social media"
    >
      {links.map((item) => (
        <a
          key={item.id}
          href={item.url}
          target="_blank"
          rel="noreferrer"
          aria-label={item.label}
          title={item.label}
          className={`
            inline-flex
            items-center
            justify-center
            rounded-full
            border
            border-border
            text-muted
            transition-all
            duration-300
            hover:border-text
            hover:text-text
            ${compact ? "h-9 w-9" : "h-11 w-11"}
          `}
        >
          <SocialIcon id={item.id} />
        </a>
      ))}
    </div>
  );
}
